import { render, staticRenderFns } from "./spreadGoods.vue?vue&type=template&id=1662b776&scoped=true"
import script from "./spreadGoods.vue?vue&type=script&lang=js"
export * from "./spreadGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662b776",
  null
  
)

export default component.exports